import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { IFair } from "../types/seed";

const API = process.env.REACT_APP_API;

const useFair = () => {
  const { slug } = useParams();
  const queryFn = async () => {
    if (!slug) {
      return { data: undefined, isLoading: false, error: null };
    }

    const response = await fetch(`${API}/api/feira_online/seeds/${slug}/fair`);
    return await response.json();
  };

  return useQuery<IFair>({
    queryKey: ["fair", slug],
    queryFn,
  });
};

export default useFair;
